var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard 9"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M96,18a6,6,0,0,1-6,6H6A6,6,0,0,1,6,12H90A6,6,0,0,1,96,18ZM90,42H6A6,6,0,0,0,6,54H90a6,6,0,0,0,0-12Zm0,30H6A6,6,0,0,0,6,84H90a6,6,0,0,0,0-12Z"}))]);
}

HamburgerInline.defaultProps = {"height":"100px","width":"100px","fill":"currentColor","viewBox":"0 0 96 96","x":"0px","y":"0px"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
